import Big from 'big.js';

class Calculator {
  /**
   * 乘法
   * @param {number} multiplicand 被乘数
   * @param {number} multiplier 乘数
   */
  times(multiplicand, multiplier) {
    const big = new Big(multiplicand);
    return +big.times(multiplier).valueOf();
  }

  /**
   * 除法
   * @param {number} divisor 除数
   * @param {number} dividend 被除数
   */
  div(divisor, dividend) {
    const big = new Big(divisor);
    return +big.div(dividend).valueOf();
  }
}

export default Calculator;
